import type { components, operations } from '@/types/schemas/api.main';
import { GET, setParams } from '../../_http';
type controller = operations['BrokerScenariosRetrieveScenarioController_get'];

export type BrokerRetrieveScenarioQuery = controller['parameters']['query'];
export type BrokerScenarioBorrowerDto = components['schemas']['BrokerScenarioBorrowerDto'];
export type BrokerRetrieveScenarioResponse = controller['responses']['200']['content']['application/json'];

export const retrieveBrokerScenario = GET(
  '/brokers/scenarios/scenario',
  setParams<BrokerRetrieveScenarioQuery>,
)<BrokerRetrieveScenarioResponse>;
